/**
 * @generated SignedSource<<a8e88a5756631f463bd8c8032a631d1b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TurnListProvider_salesAssociatesConnection$data = {
  readonly edges: ReadonlyArray<{
    readonly node: {
      readonly id: string;
      readonly " $fragmentSpreads": FragmentRefs<"utils_salesAssociate">;
    };
  }>;
  readonly " $fragmentSpreads": FragmentRefs<"SalesAssociatesModal_salesAssociatesConnection">;
  readonly " $fragmentType": "TurnListProvider_salesAssociatesConnection";
};
export type TurnListProvider_salesAssociatesConnection$key = {
  readonly " $data"?: TurnListProvider_salesAssociatesConnection$data;
  readonly " $fragmentSpreads": FragmentRefs<"TurnListProvider_salesAssociatesConnection">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TurnListProvider_salesAssociatesConnection",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "SalesAssociateEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "SalesAssociate",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            {
              "kind": "InlineDataFragmentSpread",
              "name": "utils_salesAssociate",
              "selections": [
                (v0/*: any*/),
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "OutOfStoreListItem_salesAssociate"
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "InStoreListItem_salesAssociate"
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "MovementsModal_salesAssociate"
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "OccurrencesModal_salesAssociate"
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "SalesAssociatesContentTemplateItem_salesAssociate"
                }
              ]
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SalesAssociatesModal_salesAssociatesConnection"
    }
  ],
  "type": "SalesAssociateConnection",
  "abstractKey": null
};
})();

(node as any).hash = "deab12dc18d6c481195fb5d08f40d331";

export default node;
